import React, { useContext, useEffect, useState } from 'react';
import classes from './Footer.module.css';
import logoForDark from './FP Logo files/FP v1 w.png';
import logoForLight from './FP Logo files/FP v1.png';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './../../store/index';
import { ThemeContext } from '../../App';
import { useGetAllNewsQuery } from '../../services/newsService';
import { Article } from '../../types/api';

export default function Footer() {
  const [news, setNews] = useState<Article[] | undefined>();
  const storedNews = useSelector((state: RootState) =>
    state.news.news.slice(0, 4),
  );
  const { data: newsData, refetch } = useGetAllNewsQuery(undefined, {
    skip: storedNews.length > 0,
  });

  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    if (storedNews.length) return setNews(storedNews.slice(0, 4));
    if (newsData?.length) return setNews(newsData.slice(0, 4));

    refetch();
  }, [storedNews.length, newsData?.length, refetch]);

  return (
    <>
      <div
        id={classes[theme]}
        className={classes.container + ' justify-around lg:justify-between'}
      >
        <div className={classes.firstBlock + ' hidden lg:block'}>
          <img src={theme === 'dark' ? logoForDark : logoForLight} alt="logo" />
        </div>
        <div
          className={
            classes.secondBlock +
            ' text-smSepBtnTxt md:text-mdTitlesForH lg:text-lg2AddTxt'
          }
        >
          <ul className="inline-flex flex-col">
            <Link to="/" className="mb-bottom-vh2 lg:mb-bottom-vh1">
              Home
            </Link>
            <Link to="/aboutUs" className="mb-bottom-vh2 lg:mb-bottom-vh1">
              About us
            </Link>
            <Link
              to="/uiDevelopment"
              className="mb-bottom-vh2 lg:mb-bottom-vh1"
            >
              UI Development
            </Link>
            <Link
              to="/dataManagement"
              className="mb-bottom-vh2 lg:mb-bottom-vh1"
            >
              Data Management
            </Link>
            <Link to="/industryNews" className="mb-bottom-vh2 lg:mb-bottom-vh1">
              Industry news
            </Link>
            <Link to="/contactUs" className="mb-bottom-vh2 lg:mb-bottom-vh1">
              Contact us
            </Link>
          </ul>
        </div>
        <div
          className={
            classes.thirdBlock +
            ' text-smSepBtnTxt md:text-mdTitlesForH lg:text-lg2AddTxt'
          }
        >
          <ul className="flex flex-col items-center">
            {news
              ? news.map((article) => (
                  <Link
                    to={article.url}
                    className={
                      classes.newsLink +
                      ' w-4/5 mb-bottom-vh2 lg:mb-bottom-vh2 '
                    }
                  >
                    {article.title ? article.title : undefined}
                  </Link>
                ))
              : null}
          </ul>
        </div>
      </div>
      <div
        id={classes[theme]}
        className={
          classes.bottomContainer +
          ' text-smAddTxt md:text-lgTitlesForH lg:text-lg2AddTxt flex-col lg:flex-row'
        }
      >
        <p className="mb-bottom-vh2 w-4/5 lg:w-fit ml-0">
          Copyright B© since 2024, FP Technologies LLC, All Right Reserved.
        </p>
        <Link to="privacyAndResponsibility" className={classes.privacy + ' '}>
          Privacy & Responsibility
        </Link>
      </div>
    </>
  );
}
